import React from "react";
import moment from "moment";
import * as Icon from "react-feather";

import "./subsequent-activity-modal.css";

import BookkeepingService from "../../../../services/BookkeepingService";
import UtilityService from "../../../../services/UtilityService";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";

class SubsequentActivityModal extends WComponent {
	constructor(props) {
		super(props);

		this.cancelled = false;
		this.state = {
			loading: true,
			loadError: "",
			transactions: [],
			windowStart: "",
			windowEnd: "",
		};
	}

	componentDidMount = async () => {
		const { clientId, fiscalPeriod } = this.props;

		const activity = await BookkeepingService.readStatementRegistry({
			clientId,
			view: "subsequent",
			periodEnd: fiscalPeriod.periodEnd,
		});
		if (this.cancelled) return;

		if (!activity || activity.error) {
			await this.update({ loading: false, loadError: (activity && activity.error) || "The statement registry could not be read." });
			return;
		}

		await this.update({
			loading: false,
			transactions: activity.transactions || [],
			windowStart: activity.windowStart || "",
			windowEnd: activity.windowEnd || "",
		});
	};

	componentWillUnmount() {
		this.cancelled = true;
	}

	renderTransactionRow = (transaction, index) => {
		return (
			<div key={index} className="sa-modal__line">
				<span className="sa-modal__line-date">{transaction.date ? moment(transaction.date).format("MMM D, YYYY") : "—"}</span>
				<span className="sa-modal__line-description" title={transaction.description}>{transaction.description}</span>
				<span className="sa-modal__line-account">{transaction.accountLabel || "—"}</span>
				<span className="sa-modal__line-amount">{UtilityService.formatCurrency(transaction.amount)}</span>
			</div>
		);
	};

	renderContent = () => {
		const { fiscalPeriod } = this.props;
		const { loading, loadError, transactions, windowEnd } = this.state;

		if (loading) {
			return <p className="sa-modal__note">Reading the statements on file…</p>;
		}
		if (loadError) {
			return <p className="sa-modal__note sa-modal__note--error">{loadError}</p>;
		}
		if (transactions.length === 0) {
			return (
				<p className="sa-modal__note">
					No bank activity is on file after {moment(fiscalPeriod.periodEnd).format("MMM D, YYYY")}. It appears here once next period's statements are imported — including the tail of a statement that straddles this year-end.
				</p>
			);
		}

		return (
			<React.Fragment>
				<div className="sa-modal__banner">
					<Icon.Info size={14} />
					<span className="sa-modal__banner-text">
						These {transactions.length} transactions are dated after the {moment(fiscalPeriod.periodEnd).format("MMM D, YYYY")} year-end (through {moment(windowEnd).format("MMM D, YYYY")}). They are <strong>not in these books</strong> — they are shown from the statements on file as evidence for accruals, payables and receivables at year-end.
					</span>
				</div>
				<div className="sa-modal__table">
					<div className="sa-modal__line sa-modal__line--headings">
						<span className="sa-modal__line-date">Date</span>
						<span className="sa-modal__line-description">Description</span>
						<span className="sa-modal__line-account">Account</span>
						<span className="sa-modal__line-amount">Amount</span>
					</div>
					{transactions.map(this.renderTransactionRow)}
				</div>
			</React.Fragment>
		);
	};

	render() {
		const { onClose } = this.props;

		return (
			<ToolsModal open={true} onClose={onClose} title="After year-end activity" width={720}>
				{this.renderContent()}
			</ToolsModal>
		);
	}
}

export default SubsequentActivityModal;
